import { render } from "./ConfirmModalComponent.vue?vue&type=template&id=dc15a464&ts=true"
import script from "./ConfirmModalComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmModalComponent.vue?vue&type=script&lang=ts"

import "./ConfirmModalComponent.vue?vue&type=style&index=0&id=dc15a464&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn});
